module.exports = __webpack_public_path__ + "img/avatar.4d45f3cb.png";